import React from 'react'

export default function EditLarge(props) {
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.0252 11.4934L12.0094 11.4934C8.69052 11.4934 6 14.1839 6 17.5028V37.5343C6 40.8532 8.69051 43.5437 12.0094 43.5437H32.0409C35.3598 43.5437 38.0503 40.8532 38.0503 37.5343V27.5186H35.0456V37.5343C35.0456 39.1938 33.7004 40.539 32.0409 40.539H12.0094C10.35 40.539 9.00472 39.1938 9.00472 37.5343V17.5028C9.00472 15.8434 10.35 14.4981 12.0094 14.4981H22.0252V11.4934Z'
        fill='currentColor'
      />
      <path d='M26.802 20.6624L38.575 8.88943' stroke='currentColor' strokeWidth={5.00786} />
      <path
        d='M27.8879 23.1436L24.3653 19.621L22.9633 24.5095L27.8879 23.1436Z'
        fill='currentColor'
      />
      <rect
        x={38.9348}
        y={5.00002}
        width={4.99167}
        height={2.00315}
        transform='rotate(45 38.9348 5.00002)'
        fill='currentColor'
      />
    </svg>
  )
}
